/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  Piece,
  PieceResponse,
  SearchPiecesRequest,
  SearchPiecesResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    PieceFromJSON,
    PieceToJSON,
    PieceResponseFromJSON,
    PieceResponseToJSON,
    SearchPiecesRequestFromJSON,
    SearchPiecesRequestToJSON,
    SearchPiecesResponseFromJSON,
    SearchPiecesResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnPieceByIdRequest {
    pieceId: string;
    contentType: CreateChangeRequestOnPieceByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnPieceByIdAcceptEnum;
    traceparent?: string;
}

export interface CreatePieceRequest {
    contentType: CreatePieceContentTypeEnum;
    xBOLMemberIdentifier: string;
    piece: Piece;
    id?: string;
    source?: boolean;
    accept?: CreatePieceAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreatePieceEventRequest {
    pieceId: string;
    contentType: CreatePieceEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreatePieceEventAcceptEnum;
    traceparent?: string;
}

export interface DeletePieceACLAuthorizationByMemberIdRequest {
    pieceId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeletePieceByIdRequest {
    pieceId: string;
    traceparent?: string;
}

export interface DeletePieceEventByIdRequest {
    pieceId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnPieceByIdRequest {
    pieceId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnPieceByIdAcceptEnum;
    traceparent?: string;
}

export interface GetPieceACLAuthorizationByMemberIdRequest {
    pieceId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetPieceACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetPieceACLByIdRequest {
    pieceId: string;
    at?: string;
    revision?: string;
    accept?: GetPieceACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetPieceByIdRequest {
    pieceId: string;
    at?: string;
    revision?: string;
    accept?: GetPieceByIdAcceptEnum;
    traceparent?: string;
}

export interface GetPieceEventsRequest {
    pieceId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetPieceEventsAcceptEnum;
    traceparent?: string;
}

export interface GetPieceMetadataByIdRequest {
    pieceId: string;
    accept?: GetPieceMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfPieceByIdRequest {
    pieceId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfPieceByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchPieceByIdRequest {
    pieceId: string;
    contentType: PatchPieceByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    piece: Piece;
    revision?: string;
    accept?: PatchPieceByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchPieceGetRequest {
    id?: string;
    searchBody?: SearchPiecesRequest;
    accept?: SearchPieceGetAcceptEnum;
    traceparent?: string;
}

export interface SearchPiecesPostRequest {
    contentType: SearchPiecesPostContentTypeEnum;
    searchPiecesRequest: SearchPiecesRequest;
    limit?: number;
    offset?: number;
    accept?: SearchPiecesPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnPieceByIdRequest {
    pieceId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnPieceByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnPieceByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdatePieceByIdRequest {
    pieceId: string;
    contentType: UpdatePieceByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    piece: Piece;
    revision?: string;
    accept?: UpdatePieceByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertPieceACLAuthorizationByIdRequest {
    pieceId: string;
    contentType: UpsertPieceACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertPieceACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsPiecesApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Piece resource, identified by its `PieceId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Piece resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Piece resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Piece resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Piece
     */
    async createChangeRequestOnPieceByIdRaw(requestParameters: CreateChangeRequestOnPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling createChangeRequestOnPieceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnPieceById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnPieceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/change-requests`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Piece resource, identified by its `PieceId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Piece resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Piece resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Piece resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Piece
     */
    async createChangeRequestOnPieceById(requestParameters: CreateChangeRequestOnPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnPieceByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new Piece.  When creating a Piece, the value of the header `X-BOL-Member-Identifier` defines the Piece\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Piece, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Piece and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Piece, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Piece.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Piece
     */
    async createPieceRaw(requestParameters: CreatePieceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PieceResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createPiece().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createPiece().'
            );
        }

        if (requestParameters['piece'] == null) {
            throw new runtime.RequiredError(
                'piece',
                'Required parameter "piece" was null or undefined when calling createPiece().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PieceToJSON(requestParameters['piece']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PieceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new Piece.  When creating a Piece, the value of the header `X-BOL-Member-Identifier` defines the Piece\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Piece, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Piece and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Piece, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Piece.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Piece
     */
    async createPiece(requestParameters: CreatePieceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PieceResponse | null | undefined > {
        const response = await this.createPieceRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a Piece by `pieceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Piece resource. 
     * Create an Event of a Piece
     */
    async createPieceEventRaw(requestParameters: CreatePieceEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling createPieceEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createPieceEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createPieceEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createPieceEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/events`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a Piece by `pieceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Piece resource. 
     * Create an Event of a Piece
     */
    async createPieceEvent(requestParameters: CreatePieceEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPieceEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Piece resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Piece resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Piece resource. 
     * Delete an authorization of an access control list of a Piece by memberId
     */
    async deletePieceACLAuthorizationByMemberIdRaw(requestParameters: DeletePieceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling deletePieceACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deletePieceACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deletePieceACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Piece resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Piece resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Piece resource. 
     * Delete an authorization of an access control list of a Piece by memberId
     */
    async deletePieceACLAuthorizationByMemberId(requestParameters: DeletePieceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePieceACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Piece resource, identified by its `PieceId`.  - When a Piece is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Piece resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Piece resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Piece resource. 
     * Delete a Piece by pieceId
     */
    async deletePieceByIdRaw(requestParameters: DeletePieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling deletePieceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Piece resource, identified by its `PieceId`.  - When a Piece is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Piece resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Piece resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Piece resource. 
     * Delete a Piece by pieceId
     */
    async deletePieceById(requestParameters: DeletePieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePieceByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Piece resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Piece resource. 
     * Delete an event of a Piece by id
     */
    async deletePieceEventByIdRaw(requestParameters: DeletePieceEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling deletePieceEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deletePieceEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deletePieceEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Piece resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Piece resource. 
     * Delete an event of a Piece by id
     */
    async deletePieceEventById(requestParameters: DeletePieceEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePieceEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Piece, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Piece resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Piece by changeRequestId
     */
    async getChangeRequestOnPieceByIdRaw(requestParameters: GetChangeRequestOnPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling getChangeRequestOnPieceById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnPieceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Piece, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Piece resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Piece by changeRequestId
     */
    async getChangeRequestOnPieceById(requestParameters: GetChangeRequestOnPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnPieceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Piece resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Piece resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Piece by memberId
     */
    async getPieceACLAuthorizationByMemberIdRaw(requestParameters: GetPieceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling getPieceACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getPieceACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Piece resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Piece resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Piece by memberId
     */
    async getPieceACLAuthorizationByMemberId(requestParameters: GetPieceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getPieceACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Piece resource, identified by its `PieceId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Piece and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Piece resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Piece for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getPieceACLByIdRaw(requestParameters: GetPieceACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling getPieceACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/acl`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Piece resource, identified by its `PieceId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Piece and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Piece resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Piece for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getPieceACLById(requestParameters: GetPieceACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getPieceACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific Piece by its `PieceId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Piece resource. 
     * Get a Piece by pieceId
     */
    async getPieceByIdRaw(requestParameters: GetPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PieceResponse>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling getPieceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PieceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific Piece by its `PieceId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Piece resource. 
     * Get a Piece by pieceId
     */
    async getPieceById(requestParameters: GetPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PieceResponse> {
        const response = await this.getPieceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a Piece by `pieceId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Piece resource. 
     * List Events of a Piece
     */
    async getPieceEventsRaw(requestParameters: GetPieceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling getPieceEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/events`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a Piece by `pieceId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Piece resource. 
     * List Events of a Piece
     */
    async getPieceEvents(requestParameters: GetPieceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getPieceEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Piece by its `PieceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Piece metadata by pieceId
     */
    async getPieceMetadataByIdRaw(requestParameters: GetPieceMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling getPieceMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/metadata`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Piece by its `PieceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Piece metadata by pieceId
     */
    async getPieceMetadataById(requestParameters: GetPieceMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getPieceMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Piece, identified by its `PieceId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Piece resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Piece resource. 
     * Get a list of ChangeRequest for Piece
     */
    async listChangeRequestsOfPieceByIdRaw(requestParameters: ListChangeRequestsOfPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling listChangeRequestsOfPieceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/change-requests`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Piece, identified by its `PieceId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Piece resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Piece resource. 
     * Get a list of ChangeRequest for Piece
     */
    async listChangeRequestsOfPieceById(requestParameters: ListChangeRequestsOfPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfPieceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Piece identified by its `PieceId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Piece resource. 
     * Partially update a Piece by applying a JSON Merge Patch change request
     */
    async patchPieceByIdRaw(requestParameters: PatchPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PieceResponse>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling patchPieceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchPieceById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchPieceById().'
            );
        }

        if (requestParameters['piece'] == null) {
            throw new runtime.RequiredError(
                'piece',
                'Required parameter "piece" was null or undefined when calling patchPieceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PieceToJSON(requestParameters['piece']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PieceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Piece identified by its `PieceId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Piece resource. 
     * Partially update a Piece by applying a JSON Merge Patch change request
     */
    async patchPieceById(requestParameters: PatchPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PieceResponse> {
        const response = await this.patchPieceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Piece resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Pieces.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Piece resources. 
     * Search for Pieces
     */
    async searchPieceGetRaw(requestParameters: SearchPieceGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPiecesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPiecesResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Piece resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Pieces.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Piece resources. 
     * Search for Pieces
     */
    async searchPieceGet(requestParameters: SearchPieceGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPiecesResponse> {
        const response = await this.searchPieceGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Piece resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Pieces.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Piece resources. 
     * Search for Pieces
     */
    async searchPiecesPostRaw(requestParameters: SearchPiecesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPiecesResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchPiecesPost().'
            );
        }

        if (requestParameters['searchPiecesRequest'] == null) {
            throw new runtime.RequiredError(
                'searchPiecesRequest',
                'Required parameter "searchPiecesRequest" was null or undefined when calling searchPiecesPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPiecesRequestToJSON(requestParameters['searchPiecesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPiecesResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Piece resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Pieces.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Piece resources. 
     * Search for Pieces
     */
    async searchPiecesPost(requestParameters: SearchPiecesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPiecesResponse> {
        const response = await this.searchPiecesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Piece, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Piece resource. 
     * Accept or reject a ChangeRequest on a  Piece using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnPieceByIdRaw(requestParameters: UpdateChangeRequestOnPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling updateChangeRequestOnPieceById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnPieceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnPieceById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnPieceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Piece, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Piece resource. 
     * Accept or reject a ChangeRequest on a  Piece using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnPieceById(requestParameters: UpdateChangeRequestOnPieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnPieceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Piece identified by its `PieceId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Piece resource. 
     * Update an existing Piece by creating and applying a change request
     */
    async updatePieceByIdRaw(requestParameters: UpdatePieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PieceResponse>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling updatePieceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updatePieceById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updatePieceById().'
            );
        }

        if (requestParameters['piece'] == null) {
            throw new runtime.RequiredError(
                'piece',
                'Required parameter "piece" was null or undefined when calling updatePieceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PieceToJSON(requestParameters['piece']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PieceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Piece identified by its `PieceId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Piece resource. 
     * Update an existing Piece by creating and applying a change request
     */
    async updatePieceById(requestParameters: UpdatePieceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PieceResponse> {
        const response = await this.updatePieceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Piece resource, identified by its `PieceId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Piece resource. 
     * Upsert (create or update) an authorization of an access control list of a Piece.
     */
    async upsertPieceACLAuthorizationByIdRaw(requestParameters: UpsertPieceACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['pieceId'] == null) {
            throw new runtime.RequiredError(
                'pieceId',
                'Required parameter "pieceId" was null or undefined when calling upsertPieceACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertPieceACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertPieceACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/pieces/{pieceId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"pieceId"}}`, encodeURIComponent(String(requestParameters['pieceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Piece resource, identified by its `PieceId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Piece resource. 
     * Upsert (create or update) an authorization of an access control list of a Piece.
     */
    async upsertPieceACLAuthorizationById(requestParameters: UpsertPieceACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertPieceACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnPieceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnPieceByIdContentTypeEnum = typeof CreateChangeRequestOnPieceByIdContentTypeEnum[keyof typeof CreateChangeRequestOnPieceByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnPieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnPieceByIdAcceptEnum = typeof CreateChangeRequestOnPieceByIdAcceptEnum[keyof typeof CreateChangeRequestOnPieceByIdAcceptEnum];
/**
 * @export
 */
export const CreatePieceContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreatePieceContentTypeEnum = typeof CreatePieceContentTypeEnum[keyof typeof CreatePieceContentTypeEnum];
/**
 * @export
 */
export const CreatePieceAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreatePieceAcceptEnum = typeof CreatePieceAcceptEnum[keyof typeof CreatePieceAcceptEnum];
/**
 * @export
 */
export const CreatePieceEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreatePieceEventContentTypeEnum = typeof CreatePieceEventContentTypeEnum[keyof typeof CreatePieceEventContentTypeEnum];
/**
 * @export
 */
export const CreatePieceEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreatePieceEventAcceptEnum = typeof CreatePieceEventAcceptEnum[keyof typeof CreatePieceEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnPieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnPieceByIdAcceptEnum = typeof GetChangeRequestOnPieceByIdAcceptEnum[keyof typeof GetChangeRequestOnPieceByIdAcceptEnum];
/**
 * @export
 */
export const GetPieceACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetPieceACLAuthorizationByMemberIdAcceptEnum = typeof GetPieceACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetPieceACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetPieceACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetPieceACLByIdAcceptEnum = typeof GetPieceACLByIdAcceptEnum[keyof typeof GetPieceACLByIdAcceptEnum];
/**
 * @export
 */
export const GetPieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetPieceByIdAcceptEnum = typeof GetPieceByIdAcceptEnum[keyof typeof GetPieceByIdAcceptEnum];
/**
 * @export
 */
export const GetPieceEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetPieceEventsAcceptEnum = typeof GetPieceEventsAcceptEnum[keyof typeof GetPieceEventsAcceptEnum];
/**
 * @export
 */
export const GetPieceMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetPieceMetadataByIdAcceptEnum = typeof GetPieceMetadataByIdAcceptEnum[keyof typeof GetPieceMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfPieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfPieceByIdAcceptEnum = typeof ListChangeRequestsOfPieceByIdAcceptEnum[keyof typeof ListChangeRequestsOfPieceByIdAcceptEnum];
/**
 * @export
 */
export const PatchPieceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchPieceByIdContentTypeEnum = typeof PatchPieceByIdContentTypeEnum[keyof typeof PatchPieceByIdContentTypeEnum];
/**
 * @export
 */
export const PatchPieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchPieceByIdAcceptEnum = typeof PatchPieceByIdAcceptEnum[keyof typeof PatchPieceByIdAcceptEnum];
/**
 * @export
 */
export const SearchPieceGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchPieceGetAcceptEnum = typeof SearchPieceGetAcceptEnum[keyof typeof SearchPieceGetAcceptEnum];
/**
 * @export
 */
export const SearchPiecesPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchPiecesPostContentTypeEnum = typeof SearchPiecesPostContentTypeEnum[keyof typeof SearchPiecesPostContentTypeEnum];
/**
 * @export
 */
export const SearchPiecesPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchPiecesPostAcceptEnum = typeof SearchPiecesPostAcceptEnum[keyof typeof SearchPiecesPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnPieceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnPieceByIdContentTypeEnum = typeof UpdateChangeRequestOnPieceByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnPieceByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnPieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnPieceByIdAcceptEnum = typeof UpdateChangeRequestOnPieceByIdAcceptEnum[keyof typeof UpdateChangeRequestOnPieceByIdAcceptEnum];
/**
 * @export
 */
export const UpdatePieceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdatePieceByIdContentTypeEnum = typeof UpdatePieceByIdContentTypeEnum[keyof typeof UpdatePieceByIdContentTypeEnum];
/**
 * @export
 */
export const UpdatePieceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdatePieceByIdAcceptEnum = typeof UpdatePieceByIdAcceptEnum[keyof typeof UpdatePieceByIdAcceptEnum];
/**
 * @export
 */
export const UpsertPieceACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertPieceACLAuthorizationByIdContentTypeEnum = typeof UpsertPieceACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertPieceACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertPieceACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertPieceACLAuthorizationByIdAcceptEnum = typeof UpsertPieceACLAuthorizationByIdAcceptEnum[keyof typeof UpsertPieceACLAuthorizationByIdAcceptEnum];
